import CryptoJS from 'crypto-js';

const getRP = () => {
    const RP = decryptRP(window.localStorage?.getItem("RP"));
    return RP ? RP : null;
};

const decryptRP = (RP) => {
    if (!RP) return null;
    const bytes = CryptoJS.AES.decrypt(RP, process.env.REACT_APP_ENCRYPTION_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    try {
        return JSON.parse(decrypted);
    } catch (e) {
        console.error('Error parsing decrypted JSON:', e);
        return null;
    }
};

const saveRP = (RP) => {
    const jsonString = JSON.stringify(RP);
    const cryptedText = CryptoJS.AES.encrypt(jsonString, process.env.REACT_APP_ENCRYPTION_KEY).toString();
    window.localStorage?.setItem('RP', cryptedText);
};

const removeRP = () => {
    window.localStorage?.removeItem('RP');
};

export { getRP, decryptRP, saveRP, removeRP };
